export const OPENING = {
    // オープニングの設定
    OPENING_WAIT_TIME: 30,  //オープニングの待ち時間
}

export const PRACTICE_MESSAGE = [
    {
        ID: 1,
        TYPE: "normal",
        QUESTION: "",
        ANSWER_JP: "同意する",
        ANSWER_ROM: "douisuru",
        EXPLANATION: "",
        OPTION_1_JP: "",
        OPTION_1_ROM: "",
        OPTION_2_JP: "",
        OPTION_2_ROM: "",
        OPTION_3_JP: "",
        OPTION_3_ROM: "",
    }
];